import { StepIndicator } from "../../ui/StepIndicator/StepIndicator";
import { CustomLoadingOverlay } from "../../ui/CustomLoadingOverlay/CustomLoadingOverLay";
import { useFileUploadFlow } from "./hooks/useFileUploadFlow";
import Step1Instructions from "./steps/Step1Instructions";
import Step2Upload from "./steps/Step2Upload";
import Step3ReviewAndApprove from "./steps/Step3ReviewAndApprove";

const STEPS = [
  { label: "Instructions" },
  { label: "File Upload" },
  { label: "Validation" },
];

const STEP3_STATES = new Set([
  "validation-errors",
  "ready-for-approval",
  "approving",
]);

function FileUploadPage() {
  const { uiState, handleUpload, handleCancel } = useFileUploadFlow();

  const isStep3 = STEP3_STATES.has(uiState);

  let currentStep = 3;
  if (uiState === "idle" || uiState === "uploading") currentStep = 1;
  else if (uiState === "validating" || uiState === "file-upload-failed")
    currentStep = 2;

  return (
    <div className="flex flex-col gap-6 p-4 md:p-6">
      <CustomLoadingOverlay
        fullScreen
        visible={uiState === "uploading"}
        overlayProps={{ blur: 1.4, backgroundOpacity: 0.15 }}
        loaderProps={{ color: "primary", type: "bars" }}
      />

      {!isStep3 && (
        <div className="max-w-lg mx-auto w-full">
          <StepIndicator
            steps={STEPS}
            currentStep={currentStep}
            layout="horizontal"
          />
        </div>
      )}

      {isStep3 ? (
        <Step3ReviewAndApprove />
      ) : (
        <div className="flex flex-col gap-4 max-w-3xl mx-auto w-full">
          {(uiState === "idle" || uiState === "uploading") && (
            <Step1Instructions
              onUpload={handleUpload}
              onCancel={handleCancel}
            />
          )}
          {(uiState === "validating" || uiState === "file-upload-failed") && (
            <Step2Upload />
          )}
        </div>
      )}
    </div>
  );
}

export default FileUploadPage;
